module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<a class=\"item\">\n<section class=\"content\">\n<div class=\"title\">\n<%= resourceData.title || config.static.title %>\n<% if(resourceData.icon){ %>\n<i class=\"<%- resourceData.icon %> tab-icon\"></i>\n<% } else if(config.static && config.static.icon){ %>\n<i class=\"<%- config.static.icon %> tab-icon\"></i>\n<% } %>\n</div>\n<div class=\"subTitle\"><%= resourceData.subTitle || config.static.subTitle %></div>\n</section>\n</a>"
  , __filename = "components/templates/artCrm/activity/tabStrip/tab.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<a class=\"item\">\n<section class=\"content\">\n<div class=\"title\">\n")
    ; __line = 4
    ; __append(escapeFn( resourceData.title || config.static.title ))
    ; __append("\n")
    ; __line = 5
    ;  if(resourceData.icon){ 
    ; __append("\n<i class=\"")
    ; __line = 6
    ; __append( resourceData.icon )
    ; __append(" tab-icon\"></i>\n")
    ; __line = 7
    ;  } else if(config.static && config.static.icon){ 
    ; __append("\n<i class=\"")
    ; __line = 8
    ; __append( config.static.icon )
    ; __append(" tab-icon\"></i>\n")
    ; __line = 9
    ;  } 
    ; __append("\n</div>\n<div class=\"subTitle\">")
    ; __line = 11
    ; __append(escapeFn( resourceData.subTitle || config.static.subTitle ))
    ; __append("</div>\n</section>\n</a>")
    ; __line = 13
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/artCrm/activity/tabStrip/tab.ejs

}